const text = `
Este es un avaluo muy interesante
Segunda linea
`;

export default text;
